import { PlanType } from "./enumerations/plan-type";
import { NumericListOptions } from "./interfaces/numeric-list-options";
import i18n from "../i18n";

export const PlanTypeOptions: NumericListOptions[] = [
    {
        value: PlanType.Trial,
        label: i18n.t('general.plan.trial'),
    }, {
        value: PlanType.Enterprise,
        label: i18n.t('general.plan.enterprise'),
    },
    {
        value: PlanType.EnterpriseTrial,
        label: i18n.t('general.plan.enterpriseTrial'),
    },
    {
        value: PlanType.ThirdParty,
        label: i18n.t('general.plan.thirdParty'),
    },
    {
        value: PlanType.External,
        label: i18n.t('general.plan.external'),
    },
    // {
    //     value: PlanType.Core,
    //     label: i18n.t('general.plan.core')
    // },
    // {
    //     value: PlanType.Pro,
    //     label: i18n.t('general.plan.pro')
    // },
]

export const PlanTypeLabels: { [key: number | PlanType]: string } = {
    [PlanType.Starter]: i18n.t('general.plan.starter'),
    [PlanType.Business]: i18n.t('general.plan.business'),
    [PlanType.Enterprise]: i18n.t('general.plan.enterprise'),
    [PlanType.EnterpriseTrial]: i18n.t('general.plan.enterpriseTrial'),
    [PlanType.Trial]: i18n.t('general.plan.trial'),
    [PlanType.ThirdParty]: i18n.t('general.plan.thirdParty'),
    [PlanType.Core]: i18n.t('general.plan.core'),
    [PlanType.Pro]: i18n.t('general.plan.pro'),
    [PlanType.Partner]: i18n.t('general.plan.partner'),
    [PlanType.External]: i18n.t('general.plan.external')
}